if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.addIdToRecentlyViewed(this)      
    }

    addIdToRecentlyViewed(container) {
    const slug = container.getAttribute('data-product-slug');
    const link = container.getAttribute('data-product-link');
    const image = container.getAttribute('data-product-image');

     // Get recently viewed products from local storage (if available)
    let recentlyViewed = JSON.parse(localStorage.getItem('products-recently-viewed')) || {};

    // Remove the current product if already in the list
    if (recentlyViewed.hasOwnProperty(slug)) {
      delete recentlyViewed[slug];
    }

    // Add it back to the list
    recentlyViewed[slug] = {
      link,
      image
    };

    // Store the updated recently viewed products in local storage
    localStorage.setItem('products-recently-viewed', JSON.stringify(recentlyViewed));
  
  }

    
  });
}


